import { Injectable } from '@angular/core';

import { SmartEditLauncherService } from '@spartacus/smartedit/root';

@Injectable({
  providedIn: 'root'
})
export class CustomSmartEditLauncherService extends SmartEditLauncherService {
  isLaunchedInSmartEdit(): boolean {
    return (
      super.isLaunchedInSmartEdit() ||
      (this.location.path().split('?')[0].split('/').pop() === 'previewServlet' && !!this.cmsTicketId)
    );
  }
}
